<script>
    export default {
        name: 'importer',

        mixins: [__IMPORTER__],

        data() {
            return Object.assign({
                import: null,
                fileName: '',
                filter: {
                    year: '',
                },
                validationResult: [],
                current_step: this.init_step,
                current_step_index: this.init_step_index,
                step_array: this.init_step_array,
                steps_form: this.init_steps_form,
                step_next_url: this.init_step_next_url,
                step_back_url: this.init_step_back_url,
                import_type: 'create',
				language: 'zh_hk',
                success_msg: '',
                success_url: '',
                beforeLastStepIndex: 0,
            }, __FORM__, {locale: window.locale});
        },

        props: {
            init_step_array: {
                type: Array,
                required: true,
            },
            init_steps_form: {
                type: Object,
                required: true,
            },
            init_step: {
                type: String,
                required: true,
            },
            init_step_index: {
                type: Number,
                required: true,
            },
            init_step_next_url: {
                type: String,
                required: true,
            },
            init_step_back_url: {
                type: String,
                required: true,
            },
			step_info_url: {
				type: String,
				required: false,
				default: null,
			},
			init_import_types: {
				type: Boolean,
				required: false,
				default: true,
			},
        },
        beforeDestroy() {
            window.eventHub.$off('filter_refresh', this.fetchOption);
        },
        mounted(){
            this.totalStep = this.step_array.length;
            this.beforeLastStepIndex = this.step_array.length - 2;

            window.eventHub.$on('filter_refresh', this.fetchOption);
        },
        methods: {
        	reload() {
				this.$store.commit('clearValidationError');
				this.fileName = '';
				this.getStepInfo(0);
			},
			removeUploadFile() {
				this.fileName = '';
				document.getElementById('import').value = null;
			},
			successAndBack(url) {
        		let redirect_url = '';
        		if (typeof url != 'undefined')
				{
					redirect_url = url;
				} else {
					redirect_url = this.steps_form[this.step_array[0]]['url'];
				}
        		window.location.href = redirect_url;
			},
            clickUpload() {
                document.getElementById('import').click();
            },
            submitToValidation(route) {
				let self = this;
                self.$store.commit('clearValidationError');
                self.$store.commit('clearError');
				let formData = new FormData;
				if (self.init_import_types)
				{
					formData.append('action_type', self.import_type);
				}

				if (self.current_step_index == 0)
				{
					formData.append('import', document.getElementById('import').files[0]);
				} else {
					formData.append('valid_data', JSON.stringify(self.validationResult));
				}

				let ajaxSuccessCallbackValidation = (response) => {
					self.$nextTick(function() {
						let goToNextStep = true;

						/*
						## Validation response structure ##
						validationResult = {
						    correct: number,
						    error: array,
						    header: array
						};

						## import data response structure ##
						validationResult = {
						    error: number,
						    success: array
						};
						 */
						if (_.isUndefined(response.data.success))
                        {
                            self.validationResult = response.data;
                        }

						if (self.current_step_index == self.beforeLastStepIndex &&
                            (_.isUndefined(response.data.success) || response.data.success == 0))
						{
                            location.reload();
							goToNextStep = false;
						}
						else if (typeof response.data.success_back_url != 'undefined')
						{
							self.success_back_url = response.data.success_back_url;
						}
						if (goToNextStep)
						{
							self.getStepInfo(self.current_step_index + 1);
						}
					});
				};
				let ajaxFailCallbackValidation = (error) => {
				    console.log(error);
					if (error.response.status == '422') {
						self.$store.commit('setValidationError', error.response.data.errors);
					} else {
						self.$store.commit('setError', error.response.data.msg);
					}
				};

				this.$root.ajax_post(route, formData, ajaxSuccessCallbackValidation, ajaxFailCallbackValidation, true, {headers: {'Content-Type': 'multipart/form-data'}});
            },
            getStepInfo(stepIndex) {
				let self = this;
				let ajaxSuccessCallback = (response) => {
					self.$nextTick(function() {
						self.current_step = response.data.current_step
						self.current_step_index = response.data.current_step_index
						self.step_array = response.data.step_array
						self.steps_form = response.data.steps_form
						self.step_next_url = response.data.step_next_url
						self.step_back_url = response.data.step_back_url

                        // Injecting from __IMPORTER__
                        if(_.isFunction(self.modifier)){
                            self.modifier();
                        }
					});
				};
				let ajaxFailCallback = (error) => {
					if (error.response.status == '422') {
						self.$store.commit('setValidationError', error.response.data.errors)
					} else {
						self.$store.commit('setError', error.response.data.msg)
					}
				};

                let stepInfo_url = this.step_info_url + '/' + this.step_array[stepIndex];

				this.$root.ajax_get(stepInfo_url, ajaxSuccessCallback, ajaxFailCallback, true);
            },

            getFileName(event) {
                this.fileName = event.target.files[0] ? event.target.files[0].name : '';
            },
            fetchOption(year_id) {
        	    if (_.isArray(year_id)) {
                    this.filter.year = year_id[0];
                } else {
                    this.filter.year = year_id;
                }
            }
        },
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Importer/Importer.vue